import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../theme';
export default StyleSheet.create({
  container: {
    paddingLeft: 0,
  },
  plaque: {marginVertical: 8},
  battery: {
    marginRight: -5.83,
  },
  name: {
    fontSize: 12,
    fontFamily: textStyles.medium,
    color: colorPalette.grey9,
    flexShrink: 1,
    textAlign: 'right',
  },
});
